import { Controller } from '@hotwired/stimulus'

// Light/dark toggle. Reads the current effective theme (explicit data-theme on
// <html>, else LIGHT — the default; we do not follow the OS preference), flips
// it, writes data-theme on <html>, and persists the choice to localStorage under
// "theme". A no-flash inline script in <head> applies the saved value before
// first paint. Auto-registered by the controllers glob in
// entrypoints/application.js.
export default class extends Controller {
  toggle() {
    const root = document.documentElement
    const effective = root.getAttribute('data-theme') || 'light'
    const next = effective === 'dark' ? 'light' : 'dark'

    root.setAttribute('data-theme', next)
    try {
      localStorage.setItem('theme', next)
    } catch (e) {
      // localStorage may be unavailable (private mode); the attribute still applies.
    }
  }
}
